export const GlobalStyles = () => (
  <style>{`
    @keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.3;transform:scale(1.5)}}
    @keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
    @keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
    @keyframes slideRight{from{opacity:0;transform:translateX(-12px)}to{opacity:1;transform:translateX(0)}}
    @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
    @keyframes glow{0%,100%{box-shadow:0 0 20px rgba(0,240,160,0.1)}50%{box-shadow:0 0 40px rgba(0,240,160,0.25)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    *{box-sizing:border-box;margin:0;padding:0}
    ::-webkit-scrollbar{width:3px;height:3px}
    ::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.1);border-radius:2px}
    input,textarea,select{outline:none!important}
    input::placeholder,textarea::placeholder{color:rgba(255,255,255,0.2)!important}
    a{text-decoration:none;color:inherit}
  `}</style>
);
